import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';

const LeftContainer = styled.div`
  grid-column: 1/6;
  position: sticky;
  top: ${Spacings.SPACING_HEADER}px;
  height: fit-content;

  ${mediaQuery.uptoTablet} {
    display: none;
  }
`;

export default LeftContainer;
